import React from 'react'
import { Link } from 'gatsby'
import { getDivisionColor } from '../../utils/colorUtils'

interface CourseCardProps {
  title: string
  division: string
  requirements?: string
  slug: string
  className?: string
}


const CourseCard: React.FC<CourseCardProps> = ({ title, division, requirements, slug, className = '' }) => {
  const divisionColor = getDivisionColor(division)

  return (
    <Link to={slug} className={`block ${className}`}>
      <div className="card border-0 p-0 hover:shadow-lg transition-shadow h-full">
        <div className="p-6">
          {/* Division Badge */}
          <div className="mb-3">
            <span className={`inline-block px-3 py-1 rounded-md text-sm font-medium ${divisionColor}`}>
              {division}
            </span>
          </div>

          {/* Course Title */}
          <h3 className="text-xl font-semibold mt-0 mb-2">
            <span className="text-primary">
              {title}
            </span>
          </h3>

          {/* Requirements */}
          {requirements && (
            <div className="mb-2">
              <span className="text-sm text-text-light">Requirements: </span>
              <span className="text-sm font-medium text-text">{requirements}</span>
            </div>
          )}

          {/* Learn More Link */}
          <div className="text-primary font-medium">
            Learn More →
          </div>
        </div>
      </div>
    </Link>
  )
}

export default CourseCard